export default __webpack_public_path__ + "media/webpack.96ecc29a.png";